import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton } from '@mui/material';
import { FlagOutlined } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './AssetDetailsSection.scss';

const AssetDetailsSection = ({ assetData }) => {
	const { messages } = useIntl();
	const navigate = useNavigate();
	const [expanded, setExpanded] = useState(true);

	if (!assetData || assetData.length === 0) return null;

	const handleAssetClick = (asset) => {
		// Pass the full asset data to the asset details page via navigation state
		navigate(`/app/evir-px/asset-details/${asset.assetId}`, {
			state: {
				assetData: asset,
			},
		});
	};

	const toggleExpand = () => {
		setExpanded(!expanded);
	};

	return (
		<Box className="asset-details-section">
			<Box className="section-header">
				<Typography variant="h2" className="section-title">
					{messages.assetDetails || 'ASSET DETAILS'}
				</Typography>
				<Box className="expand-toggle" onClick={toggleExpand} style={{ cursor: 'pointer' }}>
					<Typography component="span" className="toggle-text">
						{expanded ? (messages.less || 'Less') : (messages.more || 'More')}
					</Typography>
					<IconButton
						size="small"
						className={`expand-icon ${expanded ? 'expanded' : ''}`}
						aria-label={expanded ? 'collapse' : 'expand'}
					>
						<ExpandMoreIcon />
					</IconButton>
				</Box>
			</Box>

			{expanded && assetData.map((asset, index) => (
				<Box key={asset.assetId || index} className="asset-card">
					<Typography variant="h3" className="asset-name">
						{asset.languageLabel || asset.assetName}
					</Typography>

					<table className="asset-detail-table">
						<tbody>
							<tr className="asset-detail-row">
								<td className="asset-detail-field">
									{messages.assetNumber || 'ASSET NUMBER'}
								</td>
								<td className="asset-detail-data">
									<a
										onClick={() => handleAssetClick(asset)}
										className="asset-link"
										style={{ cursor: 'pointer' }}
									>
										{asset.assetName}
									</a>
									{asset.assetCategory === 'user' && (
										<FlagOutlined className="user-asset-icon" titleAccess={messages.userCreatedAsset || 'User Created Asset'} />
									)}
								</td>
							</tr>

							{asset.zoneLayoutName && (
								<tr className="asset-detail-row">
									<td className="asset-detail-field">
										{messages.equipmentType || 'EQUIPMENT TYPE'}
									</td>
									<td className="asset-detail-data">
										{asset.zoneLayoutName}
									</td>
								</tr>
							)}

							{asset.addtlAssetInfo && asset.addtlAssetInfo.length > 0 && asset.addtlAssetInfo.map((info, idx) => (
								<tr key={idx} className="asset-detail-row">
									<td className="asset-detail-field">
										{info.languageLabel}
									</td>
									<td className="asset-detail-data">
										{info.addtlAssetContent}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</Box>
			))}
		</Box>
	);
};

export default AssetDetailsSection;
